<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['new_member'] == 1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="AddMember">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group mb-4">
                    <label for="exampleDataList" class="mb-0">Member's Name</label> <small class="text-danger">*</small>
                    <input class="form-control text-primary fw-medium" list="applicants" required @change="FilterMember"
                      v-model="applicant_name" placeholder="e.g Trevor McDaniel" />
                    <datalist id="applicants">
                      <option v-for="item in applicants" :key="item.id">{{ item.name }}-{{ item.telephone }}-{{ item.nin
                        }}</option>
                    </datalist>
                  </div>
                  <!-- Primary Telephone -->
                  <div class="form-group mb-4">
                    <label class="mb-0">Primary Telephone</label> <small class="text-danger">*</small>
                    <div class="input-group custom-phone-input">

                      <!-- Custom Dropdown Container -->
                      <div class="country-dropdown" ref="primaryDropdown">
                        <!-- Pass 'primary' to our toggle function -->
                        <button type="button" class="dropdown-toggle-btn" @click="toggleDropdown('primary')">
                          <span class="flag" v-if="primary_country_code">{{ primary_country_code.flag }}</span>
                          <span class="code">{{ primary_country_code ? primary_country_code.phonecode : '+1' }}</span>
                          <i class="mdi mdi-chevron-down"></i>
                        </button>

                        <!-- Check if 'primary' is the active dropdown -->
                        <div class="dropdown-menu-custom" v-show="activeDropdown === 'primary'">
                          <div class="search-box">
                            <input type="text" v-model="searchQuery" placeholder="Search country..."
                              class="form-control text-primary fw-medium form-control-sm" ref="primarySearchInput" />
                          </div>
                          <ul class="country-list">
                            <li v-for="country in filteredCountries" :key="country.name"
                              @click="selectCountry('primary', country)">
                              <span class="flag">{{ country.flag }}</span>
                              <span class="name">{{ country.name }}</span>
                              <span class="phonecode">{{ country.phonecode }}</span>
                            </li>
                            <li v-if="filteredCountries.length === 0" class="no-results">
                              No countries found
                            </li>
                          </ul>
                        </div>
                      </div>

                      <input v-model="telephone" @input="validatePhone('primary')" type="tel"
                        class="form-control text-primary fw-medium" placeholder="700123456"
                        :class="{ 'is-invalid': phoneError }" />
                      <span class="text-danger small d-block mt-1" v-if="phoneError">{{ phoneError }}</span>
                    </div>
                  </div>

                  <!-- Alternative Telephone -->
                  <div class="form-group mb-4">
                    <label class="mb-0">Alternative Telephone</label> <small class="text-muted">(optional)</small>
                    <div class="input-group custom-phone-input">

                      <div class="country-dropdown" ref="alternativeDropdown">
                        <!-- Pass 'alternative' to our toggle function -->
                        <button type="button" class="dropdown-toggle-btn" @click="toggleDropdown('alternative')">
                          <span class="flag" v-if="alternative_country_code">{{ alternative_country_code.flag }}</span>
                          <span class="code">{{ alternative_country_code ? alternative_country_code.phonecode : '+1'
                            }}</span>
                          <i class="mdi mdi-chevron-down"></i>
                        </button>

                        <!-- Check if 'alternative' is the active dropdown -->
                        <div class="dropdown-menu-custom" v-show="activeDropdown === 'alternative'">
                          <div class="search-box">
                            <input type="text" v-model="searchQuery" placeholder="Search country..."
                              class="form-control text-primary fw-medium form-control-sm"
                              ref="alternativeSearchInput" />
                          </div>
                          <ul class="country-list">
                            <li v-for="country in filteredCountries" :key="country.name"
                              @click="selectCountry('alternative', country)">
                              <span class="flag">{{ country.flag }}</span>
                              <span class="name">{{ country.name }}</span>
                              <span class="phonecode">{{ country.phonecode }}</span>
                            </li>
                            <li v-if="filteredCountries.length === 0" class="no-results">
                              No countries found
                            </li>
                          </ul>
                        </div>
                      </div>

                      <input v-model="alternative_telephone" type="tel" class="form-control text-primary fw-medium"
                        placeholder="700123456" />
                    </div>
                  </div>
                  <div class="row form-group mb-4">
                    <div class="col-6">
                      <label class="mb-0">Gender</label> <small class="text-danger">*</small>
                      <select class="form-control text-primary fw-medium" v-model="gender" required>
                        <option value="" disabled>Select Gender</option>
                        <option>Female</option>
                        <option>Male</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <label for="input-date1" class="mb-0">Date of Birth</label> <small class="text-danger">*</small>
                      <input v-model="dateofbirth" type="date" class="form-control text-primary fw-medium" />
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Nationality</label> <small class="text-danger">*</small>
                    <v-select :options="countries" placeholder="Enter Nationality" v-model="nationality" label="name"
                      :reduce="nationality => nationality.id"></v-select>
                  </div>
                  <div class="form-group mb-4">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="mb-0">Marital Status <small class="text-secondary">(optional)</small></label>
                      <span v-if="marital_status" class="text-danger fw-medium fst-italic" style="cursor: pointer;"
                        @click="marital_status = ''">Clear</span>
                    </div> <select class="form-control text-primary fw-medium" v-model="marital_status">
                      <option value="" disabled>Select Marital Status</option>
                      <option>Single</option>
                      <option>Married</option>
                      <option>Divorced</option>
                      <option>Widowed</option>
                    </select>
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">NIN/Passport Number</label> <small class="text-danger">*</small>
                    <input v-model="nin" @input="formatNIN" required placeholder="e.g CM123ABC456DEF" type="text"
                      class="form-control text-primary fw-medium" />
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Address</label> <small class="text-danger">*</small>
                    <input v-model="address" placeholder="e.g Nakasero" type="text"
                      class="form-control text-primary fw-medium" />
                  </div>
                </div>

                <div class="col-lg-4">
                  <div class="form-group mb-4">
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="mb-0">Source of Income <small class="text-secondary">(optional)</small></label>
                      <span v-if="source_of_income" class="text-danger fw-medium fst-italic" style="cursor: pointer;"
                        @click="source_of_income = ''">Clear</span>
                    </div>
                    <select class="form-control text-primary fw-medium" v-model="source_of_income">
                      <option value="" disabled>Select Source of Income</option>
                      <option>Formal Employment</option>
                      <option>Freelancer</option>
                      <option>Business</option>
                      <option>Property or Remittances</option>
                      <option>Agriculture</option>
                      <option>Other</option>
                    </select>

                  </div>

                  <div class="form-group mb-4">
                    <label class="mb-0">Sacco Member Id</label> <small class="text-muted">(optional)</small>
                    <input v-model="sacco_member_id" placeholder="e.g TM-123-ABC" type="text"
                      class="form-control text-primary fw-medium" />
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Email Address</label> <small class="text-muted">(optional)</small>
                    <input v-model="email" @input="validateEmail" @blur="CheckEmail" type="email"
                      placeholder="e.g trevor@gmail.com" class="form-control text-primary fw-medium"
                      :class="{ 'is-invalid': emailError }" />
                    <span class="text-danger small" v-if="emailError">{{ emailError }}</span>
                  </div>
                  <div class="form-group mb-4">
                    <label for="input-date1" class="mb-0">Username</label> <small class="text-danger">*</small>
                    <input v-model="username" @input="formatUsername" @blur="CheckUsername" required
                      placeholder="e.g trevor123" type="text" class="form-control text-primary fw-medium"
                      :class="{ 'is-invalid': usernameError }" />
                    <span class="text-danger small" v-if="usernameError">{{ usernameError }}</span>
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Saving Package</label> <small class="text-danger">*</small>
                    <v-select :options="savingpackages" placeholder="Enter Saving Package" v-model="savingpackage"
                      label="name" :reduce="savingpackage => savingpackage.id"></v-select>
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Next of Kin Name</label> <small class="text-danger">*</small>
                    <input v-model="nokname" required placeholder="e.g Trevor McDaniel" type="text"
                      class="form-control text-primary fw-medium" />
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Next of Kin Contact</label> <small class="text-danger">*</small>
                    <div class="input-group custom-phone-input">

                      <!-- Custom Dropdown Container -->
                      <div class="country-dropdown" ref="nokDropdown">
                        <!-- Pass 'nok' to our toggle function -->
                        <button type="button" class="dropdown-toggle-btn" @click="toggleDropdown('nok')">
                          <span class="flag" v-if="nok_country_code">{{ nok_country_code.flag }}</span>
                          <span class="code">{{ nok_country_code ? nok_country_code.phonecode : '+1' }}</span>
                          <i class="mdi mdi-chevron-down"></i>
                        </button>

                        <!-- Check if 'nok' is the active dropdown -->
                        <div class="dropdown-menu-custom" v-show="activeDropdown === 'nok'">
                          <div class="search-box">
                            <input type="text" v-model="searchQuery" placeholder="Search country..."
                              class="form-control text-primary fw-medium form-control-sm" ref="nokSearchInput" />
                          </div>
                          <ul class="country-list">
                            <li v-for="country in filteredCountries" :key="country.name"
                              @click="selectCountry('nok', country)">
                              <span class="flag">{{ country.flag }}</span>
                              <span class="name">{{ country.name }}</span>
                              <span class="phonecode">{{ country.phonecode }}</span>
                            </li>
                            <li v-if="filteredCountries.length === 0" class="no-results">
                              No countries found
                            </li>
                          </ul>
                        </div>
                      </div>

                      <!-- Note: I kept your ref="nextInput" here in case you use it for auto-focusing -->
                      <input ref="nextInput" v-model="nokcontact" required @input="validatePhone('nok')" type="tel"
                        class="form-control text-primary fw-medium" placeholder="700123456"
                        :class="{ 'is-invalid': nokPhoneError }" />
                      <span class="text-danger small d-block mt-1" v-if="nokPhoneError">{{ nokPhoneError }}</span>
                    </div>
                  </div>
                  <div class="form-group mb-4">
                    <label class="mb-0">Relationship with Next of Kin</label> <small class="text-danger">*</small>
                    <input v-model="nok_relationship" required placeholder="e.g. Father, Mother, Workmate" type="text"
                      class="form-control text-primary fw-medium" />
                  </div>
                </div>
                <div class="col-lg-4">


                  <div class="form-group mb-4">
                    <label class="mb-0">Other information</label> <small class="text-muted">(optional)</small>
                    <textarea v-model="other_information" placeholder="e.g. Additional details about the member"
                      rows="3" class="form-control text-primary fw-medium"></textarea>
                  </div>
                  <div>
                    <h3>Documents <span class="text-muted"><i>(optional)</i></span></h3>
                    <div class="row mb-5">

                      <!-- PASSPORT PICTURE DROPZONE -->
                      <div class="fw-medium col-6">
                        Passport Picture
                        <div
                          class="dropzone-area flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4 rounded"
                          style="border: 2px dashed #dee2e6; transition: all 0.3s ease; height: 100%;"
                          :class="{ 'border-primary bg-light': isDraggingPassport, 'opacity-50 cursor-not-allowed': loading }"
                          @dragover.prevent="!loading && (isDraggingPassport = true)"
                          @dragleave.prevent="isDraggingPassport = false"
                          @drop.prevent="!loading && handleDrop($event, 'passport')"
                          @click="!loading && triggerFileInput('passport')">

                          <input type="file" ref="passportInput" @change="handleFileUpload($event, 'passport')"
                            accept="image/*" class="d-none" :disabled="loading" />

                          <div v-if="!passportFile" class="text-center text-muted" style="pointer-events: none;">
                            <i class="mdi mdi-cloud-upload-outline display-3"></i>
                            <h5 class="mt-2 text-dark">Click or drag file here</h5>
                            <p class="mb-0 small">Maximum file size 1MB.</p>
                            <p class="mb-0 small text-primary fw-medium">Image Only</p>
                          </div>

                          <div v-else class="text-center w-100">
                            <div
                              class="document-preview-wrapper mx-auto mb-3 bg-white border shadow-sm rounded overflow-hidden d-flex flex-column"
                              style="height: 280px;">
                              <!-- Changed to IMG tag for images -->
                              <img v-if="passportPreview" :src="passportPreview" class="w-100 flex-grow-1 border-0"
                                style="object-fit: cover;" alt="Passport Preview" />
                              <div v-else
                                class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-3">
                                <i class="mdi mdi-image-broken text-danger display-4"></i>
                                <span class="text-muted">Preview not available</span>
                              </div>
                              <div class="bg-light p-2 d-flex justify-content-between align-items-center border-top">
                                <div class="text-truncate fw-bold text-dark text-start" style="max-width: 70%;">{{
                                  passportFile.name }}</div>
                                <div class="text-muted small">{{ formatBytes(passportFile.size) }}</div>
                              </div>
                            </div>
                            <b-button size="sm" variant="outline-danger" @click.stop="removeFile('passport')"
                              :disabled="loading">
                              <i class="mdi mdi-trash-can-outline me-1"></i> Remove File
                            </b-button>
                          </div>
                        </div>
                      </div>

                      <!-- NATIONAL ID / PASSPORT PDF DROPZONE -->
                      <div class="fw-medium col-6">
                        National ID/Passport
                        <div
                          class="dropzone-area flex-grow-1 d-flex flex-column align-items-center justify-content-center p-4 rounded"
                          style="border: 2px dashed #dee2e6; transition: all 0.3s ease; height: 100%;"
                          :class="{ 'border-primary bg-light': isDraggingId, 'opacity-50 cursor-not-allowed': loading }"
                          @dragover.prevent="!loading && (isDraggingId = true)"
                          @dragleave.prevent="isDraggingId = false" @drop.prevent="!loading && handleDrop($event, 'id')"
                          @click="!loading && triggerFileInput('id')">

                          <input type="file" ref="idInput" @change="handleFileUpload($event, 'id')"
                            accept="application/pdf" class="d-none" :disabled="loading" />

                          <div v-if="!idFile" class="text-center text-muted" style="pointer-events: none;">
                            <i class="mdi mdi-cloud-upload-outline display-3"></i>
                            <h5 class="mt-2 text-dark">Click or drag file here</h5>
                            <p class="mb-0 small">Maximum file size 5MB.</p>
                            <p class="mb-0 small text-primary fw-medium">PDF Only</p>
                          </div>

                          <div v-else class="text-center w-100">
                            <div
                              class="document-preview-wrapper mx-auto mb-3 bg-white border shadow-sm rounded overflow-hidden d-flex flex-column"
                              style="height: 280px;">
                              <iframe v-if="idPreviewUrl"
                                :src="idPreviewUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'"
                                class="w-100 flex-grow-1 border-0" title="PDF Preview" scrolling="no"
                                style="pointer-events: none; overflow: hidden;"></iframe>
                              <div v-else
                                class="flex-grow-1 d-flex flex-column align-items-center justify-content-center p-3">
                                <i class="mdi mdi-file-pdf-box text-danger display-4"></i>
                                <span class="text-muted">Preview not available</span>
                              </div>
                              <div class="bg-light p-2 d-flex justify-content-between align-items-center border-top">
                                <div class="text-truncate fw-bold text-dark text-start" style="max-width: 70%;">{{
                                  idFile.name }}</div>
                                <div class="text-muted small">{{ formatBytes(idFile.size) }}</div>
                              </div>
                            </div>
                            <b-button size="sm" variant="outline-danger" @click.stop="removeFile('id')"
                              :disabled="loading">
                              <i class="mdi mdi-trash-can-outline me-1"></i> Remove File
                            </b-button>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="mb-3 fw-bold">
                    <div>Rules, Regulations, Policies & Constitution: <a href="#"
                        @click.prevent="downloadSaccoRules">Here</a>
                    </div>
                    <div>Data Protection & Privacy Notice: <a href="#"
                        @click.prevent="$refs.dataConsentModal.show()">Here</a></div>
                  </div>
                  <input type="checkbox" required class="form-check-input me-2" v-model="application_consent" />
                  <label class="mb-0">Membership Application Consent</label> <small class="text-danger">*</small> <br>
                  <small>By
                    clicking this box, you agree to the terms, conditions, policies and rules of the
                    organization</small>
                  <b-button type="submit" :disabled="(submitbtn <= false) || !application_consent"
                    class="btn btn-lg mt-3 w-100" variant="primary"><i class="fas fa-check-circle"></i>
                    Register</b-button>
                  <br>
                  <center><span class="text-danger">{{ error }}</span></center>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Add New Members</span></center>
          </div>
        </div>
      </div>
    </div>
    <DataConsent ref="dataConsentModal" />
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DataConsent from './dataconsent.vue';
import appConfig from "@/app.config";
import { applicantMethods, applicantComputed, savingpackageMethods, savingpackageComputed, countriesMethods, countriesComputed } from "@/state/helpers";

export default {
  page: {
    title: "Add Member",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    DataConsent
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Add Member",
      items: [{ text: "Dashboard", href: "/" }, { text: "Members", href: '/view-members' }, { text: "New Member", active: true }],
      services: [],
      applicant_name: "",
      telephone: "",
      alternative_telephone: "",
      date_of_joining: new Date().toLocaleDateString('fr-CA'),
      dateofbirth: '',
      nationality: 229,
      age: "",
      gender: "",
      email: "",
      address: "",
      nin: "",
      username: "",
      nokname: "",
      nokcontact: "",
      nok_relationship: "",
      marital_status: "",
      other_information: "",
      sacco_member_id: '',
      savingpackage: '',
      submitbtn: true,
      error: "",
      member_data: '',
      focused: false,
      emailError: "",
      phoneError: "",
      nokPhoneError: "",
      usernameError: "",

      activeDropdown: null,
      searchQuery: "",
      // Set your default selected country here
      primary_country_code: { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' },
      alternative_country_code: { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' },
      nok_country_code: { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' },

      source_of_income: "",
      application_consent: false,

      passport_photo: null,
      national_id_pdf: null,

      loading: false,

      // Passport Picture Variables
      passportFile: null,
      passportPreview: null,
      isDraggingPassport: false,

      // National ID Variables
      idFile: null,
      idPreviewUrl: null,
      isDraggingId: false,
    };
  },
  methods: {
    ...applicantMethods,
    ...countriesMethods,
    ...savingpackageMethods,

    async FilterMember() {
      let url = `/findapplicant/${this.applicant_name}`;
      await axios.get(url).then((response) => {
        if (response.data.applicants) {
          this.telephone = response.data.applicants[0].telephone;
          this.dateofbirth = response.data.applicants[0].date_of_birth;
          this.address = response.data.applicants[0].address;
          this.nin = response.data.applicants[0].nin;
          this.email = response.data.applicants[0].email;
          this.gender = response.data.applicants[0].gender;
        }
      });
    },

    validateEmail() {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.email && !re.test(this.email)) {
        this.emailError = "Please enter a valid email address.";
        this.submitbtn = false;
      } else {
        this.emailError = "";
        this.submitbtn = true;
      }
    },
    validatePhone(type) {
      const re = /^[0-9]{7,15}$/; // Ensures only numbers, between 7 and 15 digits
      if (type === 'primary') {
        if (this.telephone && !re.test(this.telephone)) {
          this.phoneError = "Phone number must contain 7 to 15 digits only.";
        } else {
          this.phoneError = "";
        }
      } else if (type === 'nok') {
        if (this.nokcontact && !re.test(this.nokcontact)) {
          this.nokPhoneError = "Phone number must contain 7 to 15 digits only.";
        } else {
          this.nokPhoneError = "";
        }
      }
    },

    formatNIN(event) {
      let value = event.target.value;
      // Convert to uppercase and strip out anything that isn't A-Z or 0-9
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      this.nin = value;
      // Force the input to update immediately 
      event.target.value = value;
    },

    formatUsername(event) {
      let value = event.target.value;
      // Strip special characters, allowing only letters, numbers, and underscores
      value = value.replace(/[^a-zA-Z0-9_]/g, '');
      this.username = value;
      event.target.value = value;

      // Trigger your existing username check
      this.CheckUsername();
    },

    async CheckUsername() {
      if (!this.username) {
        this.usernameError = "";
        return;
      }

      let formData = new FormData();
      formData.append("username", this.username);
      let url = "/check-username";

      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          if (response.data == 1) {
            this.usernameError = 'This username is already taken.';
            this.submitbtn = false;
          } else {
            this.usernameError = "";
            // Only re-enable the submit button if the email is also valid
            if (!this.emailError) {
              this.submitbtn = true;
            }
          }
        }
      });
    },

    async CheckEmail() {
      // Skip backend check if the field is empty or already failing basic regex format
      if (!this.email || this.emailError) {
        if (!this.email) {
          this.emailError = ""; // Clear error if the user deletes the text
          this.submitbtn = true;
        }
        return;
      }

      let formData = new FormData();
      formData.append("email", this.email);

      await axios.post("/checkemail", formData).then((response) => {
        if (response.status == 200) {
          if (response.data == 1) {
            this.emailError = 'This email is already registered to an active member.';
            this.submitbtn = false;
          } else {
            this.emailError = "";
            this.submitbtn = true;
          }
        }
      });
    },

    async AddMember() {
      this.validateEmail();
      this.validatePhone('primary');
      this.validatePhone('nok');

      if (this.emailError || this.phoneError || this.nokPhoneError) {
        this.error = "Please fix the validation errors before submitting.";
        return;
      }

      this.error = "Saving Member Visit";
      this.submitbtn = false;
      let formData = new FormData();

      // Required Fields
      formData.append("member", this.applicant_name);
      formData.append("date_of_joining", this.date_of_joining);
      formData.append("primary_country_code", this.primary_country_code ? this.primary_country_code.phonecode : '');
      formData.append("telephone", this.telephone);
      formData.append("gender", this.gender);
      formData.append("date_of_birth", this.dateofbirth);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("nin", this.nin);
      formData.append("username", this.username);
      formData.append("nokname", this.nokname);
      formData.append("nok_country_code", this.nok_country_code ? this.nok_country_code.phonecode : ''); // Fixed bug: changed from nokcountry_code to nok_country_code
      formData.append("nokcontact", this.nokcontact);
      formData.append("nok_relationship", this.nok_relationship);
      formData.append("savingpackage", this.savingpackage);
      formData.append("membership_application_consent", this.application_consent);

      // Optional string/select fields (Only append if they have a value)
      if (this.alternative_telephone) {
        formData.append("alternative_country_code", this.alternative_country_code ? this.alternative_country_code.phonecode : '');
        formData.append("alternative_telephone", this.alternative_telephone);
      }
      if (this.email) formData.append("email", this.email);
      if (this.marital_status) formData.append("marital_status", this.marital_status);
      if (this.source_of_income) formData.append("source_of_income", this.source_of_income);
      if (this.other_information) formData.append("other_information", this.other_information);
      if (this.sacco_member_id) formData.append("sacco_member_id", this.sacco_member_id);

      // Optional Documents (Only append if files were dropped/uploaded)
      if (this.passportFile) {
        formData.append("passport_picture", this.passportFile);
      }
      if (this.idFile) {
        formData.append("national_id_doc", this.idFile);
      }

      let url = "/addmember";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            // Clear Files After Success
            this.removeFile('passport');
            this.removeFile('id');

            this.fetchApplicants();

            // Reset form variables
            this.applicant_name = "";
            this.primary_country_code = { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' };
            this.alternative_country_code = { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' };
            this.nok_country_code = { name: 'Uganda', phonecode: '+256', flag: '🇺🇬' };
            this.telephone = "";
            this.alternative_telephone = "";
            this.address = "";
            this.email = "";
            this.nin = "";
            this.username = "";
            this.nokname = "";
            this.nokcontact = "";
            this.nok_relationship = "";
            this.marital_status = "";
            this.other_information = "";
            this.sacco_member_id = "";
            this.savingpackage = "";
            this.source_of_income = "";
            this.application_consent = false;

            this.$toast.success("New Member Added");
            this.error = "";
            this.submitbtn = true;
          }
        });
      } catch (error) {
        // If the backend returns a 422 Unprocessable Entity, handle validation visually
        let errorMsg = "Error Adding Member. Check required fields";
        if (error.response && error.response.data && error.response.data.errors) {
          // Fetching the first error message to display
          const firstKey = Object.keys(error.response.data.errors)[0];
          errorMsg = error.response.data.errors[firstKey][0];
        }
        this.error = errorMsg;
        this.submitbtn = true;
      }
    },

    toggleDropdown(type) {
      // If clicking the currently open dropdown, close it. Otherwise, open the new one.
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
        this.searchQuery = ""; // Reset search whenever a dropdown is opened

        // Focus the correct search input
        this.$nextTick(() => {
          const refName = type + 'SearchInput';
          if (this.$refs[refName]) {
            this.$refs[refName].focus();
          }
        });
      }
    },
    selectCountry(type, country) {
      // Assign the selected country to the correct variable
      if (type === 'primary') {
        this.primary_country_code = country;
      } else if (type === 'alternative') {
        this.alternative_country_code = country;
      } else if (type === 'nok') {
        this.nok_country_code = country;
      }
      this.activeDropdown = null; // Close the dropdown
    },
    handleClickOutside(event) {
      // Check if the click happened inside either of the dropdowns
      const isClickInsidePrimary = this.$refs.primaryDropdown && this.$refs.primaryDropdown.contains(event.target);
      const isClickInsideAlternative = this.$refs.alternativeDropdown && this.$refs.alternativeDropdown.contains(event.target);
      const isClickInsideNextOfKin = this.$refs.nokDropdown && this.$refs.nokDropdown.contains(event.target);
      // If the user clicked outside of BOTH dropdowns, close whichever one is open
      if (!isClickInsidePrimary && !isClickInsideAlternative && !isClickInsideNextOfKin) {
        this.activeDropdown = null;
      }
    },

    triggerFileInput(type) {
      if (type === 'passport') this.$refs.passportInput.click();
      if (type === 'id') this.$refs.idInput.click();
    },

    handleFileUpload(event, type) {
      const file = event.target.files[0];
      this.processFile(file, type);
    },

    handleDrop(event, type) {
      // Turn off drag styling
      if (type === 'passport') this.isDraggingPassport = false;
      if (type === 'id') this.isDraggingId = false;

      const file = event.dataTransfer.files[0];
      this.processFile(file, type);
    },

    processFile(file, type) {
      if (!file) return;

      if (type === 'passport') {
        // Validate Image
        if (!file.type.startsWith('image/')) {
          this.$toast.error("Please upload a valid image file.");
          return;
        }
        if (file.size > 1024 * 1024) { // 1MB limit
          this.$toast.error("Passport picture exceeds 1MB limit.");
          return;
        }
        this.passportFile = file;
        this.passportPreview = URL.createObjectURL(file);

      } else if (type === 'id') {
        // Validate PDF
        if (file.type !== 'application/pdf') {
          this.$toast.error("Please upload a valid PDF document.");
          return;
        }
        if (file.size > 5 * 1024 * 1024) { // 5MB limit
          this.$toast.error("National ID document exceeds 5MB limit.");
          return;
        }
        this.idFile = file;
        this.idPreviewUrl = URL.createObjectURL(file);
      }
    },

    removeFile(type) {
      if (type === 'passport') {
        this.passportFile = null;
        this.passportPreview = null;
        if (this.$refs.passportInput) this.$refs.passportInput.value = '';
      } else if (type === 'id') {
        this.idFile = null;
        this.idPreviewUrl = null;
        if (this.$refs.idInput) this.$refs.idInput.value = '';
      }
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },

    downloadSaccoRules() {
      let url = "/download-sacco-rules";

      axios.get(url, {
        responseType: 'blob',
        // Add this to accept 404 as a valid, non-error status
        validateStatus: function (status) {
          return (status >= 200 && status < 300) || status === 404;
        }
      })
        .then((response) => {
          // Check if response is successful and contains data
          if (response.status === 200 && response.data) {
            // Create blob from response data
            const blob = new Blob([response.data], { type: 'application/pdf' });

            // Create download link
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Rules, Regulations, Policies & Constitution.pdf";
            document.body.appendChild(link); // Append to body for better browser compatibility
            link.click();
            document.body.removeChild(link); // Clean up

            // Show success message after download starts
            this.$toast.success("Sacco Rules downloaded successfully.");
          } else if (response.status === 404) {
            // Now this block will actually execute!
            this.$toast.error("No Rules Document found. Upload the Rules Document first.");
          }
        })
        .catch(() => {
          // Handle network errors or other unexpected exceptions (e.g., 500 server errors)
          this.$toast.error("Failed to download Sacco Rules. Please try again later.");
        })
        .finally(() => {
          // Clean up object URL to prevent memory leaks
          if (this.downloadUrl) {
            window.URL.revokeObjectURL(this.downloadUrl);
          }
        });
    }
  },
  computed: {
    ...applicantComputed,
    ...countriesComputed,
    ...savingpackageComputed,
    filteredCountries() {
      if (!this.searchQuery) return this.countries;

      const query = this.searchQuery.toLowerCase();
      return this.countries.filter(c =>
        c.name.toLowerCase().includes(query) ||
        c.phonecode.includes(query)
      );
    }
  },

  mounted() {
    this.fetchApplicants();
    this.fetchSavingPackages();
    this.fetchCountries();

    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.custom-phone-input {
  display: flex;
  position: relative;
}

.country-dropdown {
  position: relative;
}

/* Make the button look exactly like a Bootstrap input-group-text */
.dropdown-toggle-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  padding: 0 12px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  border-right: none;
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
  color: #495057;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.dropdown-toggle-btn:hover {
  background-color: #e2e6ea;
}

.dropdown-toggle-btn .caret {
  font-size: 10px;
  color: #6c757d;
  margin-left: 2px;
}

/* Custom Dropdown Menu */
.dropdown-menu-custom {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  width: 280px;
  /* Wide enough for long country names */
  margin-top: 4px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.search-box {
  padding: 10px;
  border-bottom: 1px solid #e9ecef;
}

.country-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 250px;
  overflow-y: auto;
}

.country-list li {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.1s;
}

.country-list li:hover {
  background-color: #f8f9fa;
}

.country-list .name {
  flex: 1;
  margin: 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.country-list .phonecode {
  color: #6c757d;
  font-size: 13px;
  font-weight: 500;
}

.country-list .flag {
  font-size: 18px;
}

.no-results {
  padding: 12px;
  text-align: center;
  color: #6c757d;
  font-size: 14px;
}
</style>
